import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'digi-selectbox',
  templateUrl: './selectbox.component.html',
  styleUrl: './selectbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectboxComponent),
      multi: true,
    },
  ],
})
export class SelectboxComponent implements ControlValueAccessor {
  @Input() label: string = 'Select Box';
  @Input() placeholder: string = '';
  @Input() options: { value: any; label: string }[] = [];
  @Input() disabled: boolean = false;
  @Input() hint: string = '';
  @Input() errorMessage: string = '';
  @Input() control: FormControl = new FormControl();

  @Output() selectionChange = new EventEmitter<any>();

  value: any = null;

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectionChange(event: any): void {
    this.value = event.value;
    this.onChange(event.value);
    this.onTouched();
    this.selectionChange.emit(event.value);
  }
}
